export default function definePosition(string) {
  switch(string) {
    case "tc":
      return {
        string: "top: 15px; left: 50%; transform: translateX(-50%)",
        react: {top: "45px", left: "50%", transform: "translateX(-50%)"}
      }
    case "te":
      return {
        string: "top: 15px; left: 15px;",
        react: {top: "45px", left: "15px"}
      }
    case "tr":
      return {
        string: "top: 15px; right: 15px;",
        react: {top: "45px", right: "15px"}
      }
    case "cc":
      return {
        string: "top: 50%; left: 50%; transform: translate(-50%, -50%)",
        react: {top: "50%", left: "50%", transform: "translate(-50%, -50%)"}
      }
    case "ce":
      return {
        string: "top: 50%; left: 15px; transform: translateY(-50%)",
        react: {top: "50%", left: "15px", transform: "translateY(-50%)"}
      }
    case "cr":
      return {
        string: "top: 50%; right: 15px; transform: translateY(-50%)",
        react: {top: "50%", right: "15px", transform: "translateY(-50%)"}
      }
    case "fc":
      return {
        string: "bottom: 15px; left: 50%; transform: translateX(-50%)",
        react: {bottom: "15px", left: "50%", transform: "translateX(-50%)"}
      }
    case "fe":
      return {
        string: "bottom: 15px; left: 15px;",
        react: {bottom: "15px", left: "15px"}
      }
    case "fr":
      return {
        string: "bottom: 15px; right: 15px;",
        react: {bottom: "15px", right: "15px"}
      }
    default:
      return {
        string: "top: 15px; left: 15px;",
        react: {top: "45px", left: "15px"}
      }
  }

  
}